import React, {useEffect, useState} from 'react';

import {connect} from 'react-redux';
import BreadcrumbsForSearch from '../../_components/BreadcrumbsForSearch';
import PtoductsNewTable from './components/PtoductsNewTable';
import PtoductsNewTableColumns from './components/PtoductsNewTableColumns';
import {searchActions} from '../../_actions/search.actions';
import {cartActions} from '../../_actions/cart.actions';
import AddToCartDialog from './components/AddToCartDialog/AddToCartDialog';
import Filters from './components/MenuFilter/Filters';
import Grid from '@material-ui/core/Grid';
// import {Container, Hidden} from '@material-ui/core';
//Временно убрали плашки !!!
//import ArticleBrandGroup from './components/ArticleBrand/ArticleBrandGroup';
// import ProductsToolbar from './components/ProductsToolbar';
import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
// import ArticleSearch from './components/ArticleBrand/ArticleSearch';
// import SliderPhoto from '../../_components/SliderPhoto';
import {useTranslation} from 'react-i18next';
// import AboutGoods from '../../_components/AboutGoods';
import PropTypes from 'prop-types';
import {useLocation, withRouter} from 'react-router-dom';
import clsx from 'clsx';
import {
  dataProcessing,
  getCurrencyContrData,
  // history
} from '../../_helpers';
// import Typography from '@material-ui/core/Typography';
import BlockTypeToggleButton from './components/BlockTypeToggleButton';
// import FormControl from '@material-ui/core/FormControl';
// import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
// import {Sort as SortIcon} from '../../icons';
// import SortablePanel from './components/SortablePanel';
import {makeStyles} from '@material-ui/styles';
import SliderRandomProduct from '../../HomePage/components/SliderRandomProduct';
import SliderPromo from '../../HomePage/components/SliderPromo';
// import {BreadCrumbs} from '../../_components/BreadCrumbs/BreadCrumbs';
// import {userActions} from "../../_actions";

// import {ProductItem} from '../../_components/Product/ProductItem';
// import TopSlider from '../../HomePage/components/TopSlider';
import {SortForm} from './components/SortForm/SortForm';
import {PerView} from './components/PerView/PerView';
// import {PromotionsSlider} from './components/Slider/PromotionsSlider';
// import Preloader from '../../_components/Preloader';
// import {NoProducts} from './components/NoProducts/NoProducts';
import {MenuDrawer} from './components/MenuFilter/MenuDrawer';
import {ProductListSkeleton} from './components/ProductListSkeleton/ProductListSkeleton';
import NoProducts from '../../_components/NoProducts/NoProducts';
import {Helmet} from 'react-helmet';
import {catalogService} from '../../_services';
import {Skeleton} from '@material-ui/lab';
import axInst from '../../_helpers/axios-instance';
import {useHistory} from 'react-router-dom';

let searchRealAvailability = [];
let searchString = '';
let showFilter = true;

const useStyles = makeStyles(theme => ({
  randomProduct: {
    position: 'sticky',
    top: 80,
    width: '100%',
    // padding: '0 20px',
    margin: '-3px 0 0 0',
    [theme.breakpoints.down(1600)]: {
      display: 'none',
    },
    height: 490,
  },

  sliderPromoHolder: {
    // width: 'calc(100% - 25px)',

    '& .slick-list': {
      width: '100%',

      '& img': {
        objectFit: 'contain',
        // height: '300px',
      },
    },
  },

  customStyle: {
    padding: '0 3px',
  },

  searchedAtCatalogs: {
    fontSize: '13px',
    whiteSpace: 'nowrap',
    WebkitWhiteSpace: 'nowrap',
    width: 'max-content',
    [theme.breakpoints.down(411)]: {
      width: 'min-content',
      minWidth: '90px',
    },
  },
}));

let arrAllResult = [];

const ProductList = props => {
  const {
    brands,
    // history,
    main_currency,
    // user_perms,
    catalogByGroup,
    brandCatalogByGroup,
    searchByArticleOwn,
    searchByArticleOffer,
    searchByCrossOwn,
    searchByCrossOffer,
    searchByOtherOwn,
    searchByOtherOffer,
    addToCart,
    searchStatus,
    searchAvailability,
    //setSearchDataAndSearch,
    //search,
    sell_currency_id,
    customer_id,
    customer_data,
    currencies,
    cart,
    historySearch,
    // listMyFavorite,
    // getContragentData,
    searchParams,
    authentication,
    searchPromotions,
    dataPromotionList,
    brandsLayout,
    renderBrandsFilter,
    promotionLayout,
    catalogTree,
    requestForCatalogByGroup,
    onPerViewChange,
    onPageChange,
    catalogPage,
  } = props;

  // const {products: promoProducts} = dataPromotionList || {};
  // let promoProducts = {
  //     results:  dataPromotionList && dataPromotionList.products ? dataPromotionList.products : []
  // }
  let promoProducts = dataPromotionList;

  const classes = useStyles();
  const {t} = useTranslation();
  const history = useHistory();

  const [dialogData, setDialogData] = useState({});
  const [photosGallery, setPhotosGallery] = useState();
  const [sorting, setSorting] = React.useState('1');
  // const [selectUuid, setSelectUuid] = useState(false);
  const [anchorElInfo, setAnchorElInfo] = useState(null);
  // const [discountsByProduct, setDiscountsByProduct] = useState(
  //   dialogData.row && dialogData.row.discounts_by_quantity_sum_of_order,
  // );
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true,
  });
  /*const isHandset = useMediaQuery(theme.breakpoints.down('xs'), {
        defaultMatches: true,
    });*/

  let lastItemBreadcrumb = catalogPage ? catalogPage?.page_par?.name : null;

  const settingsRandomProductSlider = {
    // dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesPerRow: 1,
    rows: 2,
    autoplay: true,
    variant: 'variant2',
    autoplaySpeed: 5000,
  };
  const settingsPromotionSlider = {
    // dots: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesPerRow: 1,
    rows: 1,
    autoplay: true,
    variant: 'variant2',
    autoplaySpeed: 6000,
  };

  const customer_group_id = customer_data && customer_data.discount_group_id; // Не потерять!!!

  let cartAll = cart && cart.list ? cart.list.all : [];

  const currencyMain =
    sell_currency_id &&
    currencies &&
    currencies.find(x => x.id === sell_currency_id);

  //const currencyMainSite = getCurrencySiteData(currencyMain, main_currency, sell_currency_id);
  const currencyMainContr = getCurrencyContrData(
    currencyMain,
    main_currency,
    sell_currency_id,
    customer_data,
  );

  const [showFilterSideBar, setShowFilterSideBar] = useState(false);
  const [showSortSideBar, setShowSortSideBar] = useState(false);
  const [showPerViewSideBar, setShowPerViewSideBar] = useState(false);
  const [catalog, setCatalog] = useState({data: {filter_block: []}});
  const [userAddToCart, setUserAddToCart] = useState(false);
  const search = useLocation();
  const [hasResults, setHasResults] = useState(false);

  React.useEffect(() => {
    const hasAnyResults =
      (searchByArticleOwn.results && searchByArticleOwn.results.length > 0) ||
      (searchByCrossOwn.results && searchByCrossOwn.results.length > 0) ||
      (searchByOtherOwn.results && searchByOtherOwn.results.length > 0) ||
      (searchByArticleOffer.results &&
        searchByArticleOffer.results.length > 0) ||
      (searchByCrossOffer.results && searchByCrossOffer.results.length > 0) ||
      (searchByOtherOffer.results && searchByOtherOffer.results.length > 0);

    setHasResults(hasAnyResults);
  }, [
    searchByArticleOwn.results,
    searchByCrossOwn.results,
    searchByOtherOwn.results,
    searchByArticleOffer.results,
    searchByCrossOffer.results,
    searchByOtherOffer.results,
  ]);

  React.useEffect(() => {
    if (searchStatus.loading === false) {
      if (searchStatus.promo || searchStatus.catalog) {
      } else if (searchStatus.searchString)
        historySearch({
          name: searchStatus.searchString,
          url: `/products?q=${searchStatus.searchString}`,
        });

      let product_id = arrAllResult.map(it => it.product_id);
      /*let product_id = [];
            arrAllResult.map((it, index) => {
                if(index < 599) product_id.push(it.product_id);
            });*/

      const chunkedProductIds = [];
      for (let i = 0; i < product_id.length; i += 1000) {
        chunkedProductIds.push(product_id.slice(i, i + 1000));
      }

      chunkedProductIds.map(items => {
        searchPromotions(items);
      });
    }
    //// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchStatus.loading]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const searchStr = searchParams.get('q');

    if (
      !search.search.includes('&page=') &&
      !search.search.includes('?page=')
    ) {
      searchParams.set('page', 1);
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      history.push(newUrl);
    }

    if (
      (searchStr,
      search.search.includes('?q=') &&
        searchByArticleOwn?.results?.length === 0 &&
        searchByCrossOwn?.results?.length === 0 &&
        searchByOtherOwn?.results?.length === 0 &&
        searchByArticleOffer?.results?.length === 0 &&
        searchByCrossOffer?.results?.length === 0 &&
        searchByOtherOffer?.results?.length === 0)
    ) {
      axInst.post(
        '/api/add-search-history/',
        JSON.stringify({
          customer_id: customer_id,
          search: searchStr,
          is_added_to_basket: false,
          is_found_product_by_search: false,
        }),
      );
    } else if (!userAddToCart && searchStr) {
      const unlisten = history.listen(() => {
        axInst.post(
          '/api/add-search-history/',
          JSON.stringify({
            customer_id: customer_id,
            search: searchStr,
            is_added_to_basket: false,
            is_found_product_by_search: true,
          }),
        );
      });
      return () => {
        unlisten();
      };
    }
  }, [searchStatus.searchString, searchStatus.loading, userAddToCart, history]);

  React.useEffect(() => {
    // debugger
    // if (dialogData.row) {
    //   setDiscountsByProduct(dialogData.row.discounts_by_quantity_sum_of_order);
    // }
    //// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialogData.row]);
  React.useEffect(() => {
    catalogService
      .getCatalogTree('menu_block')
      .then(res => {
        setCatalog({data: {filter_block: [res.menu_block]}});
      })
      .catch(err => {});
  }, []);
  let stTypePage = 'cardVr';
  if (localStorage.getItem('TypePage')) {
    stTypePage = localStorage.getItem('TypePage');
  } else {
    localStorage.setItem('TypePage', stTypePage);
  }
  const [typePage, setTypePage] = useState(stTypePage);
  if (!isDesktop && stTypePage === 'table') {
    stTypePage = 'cardVr';
    setTypePage(stTypePage);
    localStorage.setItem('TypePage', stTypePage);
  }

  if (!mdUp && stTypePage !== 'cardVr') {
    stTypePage = 'cardVr';
    setTypePage(stTypePage);
    localStorage.setItem('TypePage', stTypePage);
  }

  const changeSort = event => {
    //event.persist();
    // setPageNumber(0);
    // setCountAddPage(1);
    setSorting(event.target.value);
  };

  const handleClose = props => {
    const {offers, localMainCartId} = props;
    if (offers) {
      Object.keys(offers).map(
        key =>
          offers[key].quantity > 0 &&
          addToCart(
            localMainCartId,
            key,
            offers[key].price,
            offers[key].quantity,
          ),
      );
    }
    // add to your search history
    const searchParams = new URLSearchParams(window.location.search);
    const searchStr = searchParams.get('q');
    if (searchStr) {
      axInst.post(
        '/api/add-search-history/',
        JSON.stringify({
          customer_id: customer_id,
          search: searchStr,
          is_added_to_basket: true,
          is_found_product_by_search: true,
          product_id: dialogData.row.product_id,
        }),
      );
      setUserAddToCart(true);
    }
    setDialogData({});
  };

  const handleUuidInfo = uuid => event => {
    //event.preventDefault();
    event.stopPropagation();
    // setSelectUuid(uuid);
    setAnchorElInfo(event.currentTarget);
  };
  // const handleCloseUuidInfo = () => {
  //   setAnchorElInfo(null);
  // };
  /*const showProductCart = (brand, article) => event => {
        history.push(`${'/product/'}${brand}${'/'}${article}`);
        //window.location.href = '/product/' + brand + '/' + article;
    };*/

  let countAll = '...';
  // if (searchStatus.loading === false) {
  //   arrAllResult = [];
  //   /*if(searchByArticleOwn.results){
  //           searchByArticleOwn.results = dataProcessing(currencyMain, searchByArticleOwn.results, cartAll, listMyFavorite, '', searchAvailability, []).results;
  //           arrAllResult = arrAllResult.concat(dataProcessing(currencyMain, searchByArticleOwn.results, [], [], '', searchAvailability, []).results);
  //       }*/
  //   if (searchByArticleOwn.results)
  //     arrAllResult = arrAllResult.concat(
  //       dataProcessing(
  //         currencyMain,
  //         searchByArticleOwn.results,
  //         [],
  //         [],
  //         '',
  //         searchAvailability,
  //         [],
  //       ).results,
  //     );
  //   if (searchByCrossOwn.results)
  //     arrAllResult = arrAllResult.concat(
  //       dataProcessing(
  //         currencyMain,
  //         searchByCrossOwn.results,
  //         [],
  //         [],
  //         '',
  //         searchAvailability,
  //         [],
  //       ).results,
  //     );
  //   if (searchByOtherOwn.results)
  //     arrAllResult = arrAllResult.concat(
  //       dataProcessing(
  //         currencyMain,
  //         searchByOtherOwn.results,
  //         [],
  //         [],
  //         '',
  //         searchAvailability,
  //         [],
  //       ).results,
  //     );
  //   if (searchByArticleOffer.results)
  //     arrAllResult = arrAllResult.concat(
  //       dataProcessing(
  //         currencyMain,
  //         searchByArticleOffer.results,
  //         [],
  //         [],
  //         '',
  //         searchAvailability,
  //         [],
  //       ).results,
  //     );
  //   if (searchByCrossOffer.results)
  //     arrAllResult = arrAllResult.concat(
  //       dataProcessing(
  //         currencyMain,
  //         searchByCrossOffer.results,
  //         [],
  //         [],
  //         '',
  //         searchAvailability,
  //         [],
  //       ).results,
  //     );
  //   if (searchByOtherOffer.results)
  //     arrAllResult = arrAllResult.concat(
  //       dataProcessing(
  //         currencyMain,
  //         searchByOtherOffer.results,
  //         [],
  //         [],
  //         '',
  //         searchAvailability,
  //         [],
  //       ).results,
  //     );
  //   // if (catalogByGroup.results)
  //   //   arrAllResult = arrAllResult.concat(
  //   //     dataProcessing(
  //   //       currencyMain,
  //   //       catalogByGroup.results,
  //   //       [],
  //   //       [],
  //   //       '',
  //   //       searchAvailability,
  //   //       [],
  //   //     ).results,
  //   //   );
  //   if (promoProducts.results && promoProducts.results?.length > 0) {
  //     arrAllResult = arrAllResult.concat(
  //       dataProcessing(
  //         currencyMain,
  //         promoProducts.results,
  //         [],
  //         [],
  //         '',
  //         searchAvailability,
  //         [],
  //       ).results,
  //     );
  //   }
  //
  //   countAll = arrAllResult?.length;
  //
  //   /*countAll =
  //           (searchByArticleOwn.results ? searchByArticleOwn.results.length : 0)
  //           + (searchByCrossOwn.results ? searchByCrossOwn.results.length : 0)
  //           + (searchByOtherOwn.results ? searchByOtherOwn.results.length : 0)
  //           + (searchByArticleOffer.results ? searchByArticleOffer.results.length : 0)
  //           + (searchByCrossOffer.results ? searchByCrossOffer.results.length : 0)
  //           + (searchByOtherOffer.results ? searchByOtherOffer.results.length : 0)
  //           + (catalogByGroup.results ? catalogByGroup.results.length : 0);*/
  //
  //   if (searchStatus.searchString !== searchString) {
  //     searchRealAvailability = [];
  //     /*if (countAll <2 || countAll === '...') showFilter = false;
  //           else showFilter = true;*/
  //     showFilter = countAll !== '...' && countAll > 1;
  //
  //     if (catalogByGroup.results && catalogByGroup.results?.length > 0)
  //       if (searchRealAvailability.indexOf('OWN') === -1)
  //         searchRealAvailability.push('OWN');
  //     if (searchByArticleOwn.results && searchByArticleOwn.results?.length > 0)
  //       if (searchRealAvailability.indexOf('OWN') === -1)
  //         searchRealAvailability.push('OWN');
  //     if (searchByCrossOwn.results && searchByCrossOwn.results?.length > 0)
  //       if (searchRealAvailability.indexOf('OWN') === -1)
  //         searchRealAvailability.push('OWN');
  //     if (searchByOtherOwn.results && searchByOtherOwn.results?.length > 0)
  //       if (searchRealAvailability.indexOf('OWN') === -1)
  //         searchRealAvailability.push('OWN');
  //     if (
  //       searchByArticleOffer.results &&
  //       searchByArticleOffer.results.length > 0
  //     )
  //       if (searchRealAvailability.indexOf('OFFER') === -1)
  //         searchRealAvailability.push('OFFER');
  //     if (searchByCrossOffer.results && searchByCrossOffer.results?.length > 0)
  //       if (searchRealAvailability.indexOf('OFFER') === -1)
  //         searchRealAvailability.push('OFFER');
  //     if (searchByOtherOffer.results && searchByOtherOffer.results?.length > 0)
  //       if (searchRealAvailability.indexOf('OFFER') === -1)
  //         searchRealAvailability.push('OFFER');
  //     if (promoProducts.results && promoProducts.results?.length > 0)
  //       if (searchRealAvailability.indexOf('OWN') === -1)
  //         searchRealAvailability.push('OWN');
  //
  //     searchString = searchStatus.searchString;
  //   }
  //
  //   // if (arrAllResult.length === 1 && searchParams.searchStat === 'final') {
  //   //   history.push(
  //   //     `/product/${arrAllResult[0].brand_clean}/${arrAllResult[0].article_clean}`,
  //   //   );
  //   // }
  // }

  // debugger;
  if (searchStatus.promo) showFilter = false;
  else if (searchStatus.catalog && brands && brands?.length < 1)
    showFilter = false;
  else if (searchParams && searchParams.product_group_id > 0) showFilter = true; //Заглушка!!!!!!!!!!!!!!

  const isLoading =
    searchStatus.loading || // Додаємо основний індикатор завантаження
    (catalogByGroup.loading && !catalogByGroup.results?.length) ||
    (searchByArticleOwn.loading && !searchByArticleOwn.results?.length) ||
    (searchByArticleOffer.loading && !searchByArticleOffer.results?.length) ||
    (searchByCrossOwn.loading && !searchByCrossOwn.results?.length) ||
    (searchByCrossOffer.loading && !searchByCrossOffer.results?.length) ||
    (searchByOtherOwn.loading && !searchByOtherOwn.results?.length) ||
    (searchByOtherOffer.loading && !searchByOtherOffer.results?.length) ||
    (promoProducts.loading && !promoProducts.results?.length);

  // Перевіряємо чи є хоча б один результат
  const hasAnyResults =
    searchByArticleOwn.results?.length > 0 ||
    searchByCrossOwn.results?.length > 0 ||
    searchByOtherOwn.results?.length > 0 ||
    searchByArticleOffer.results?.length > 0 ||
    searchByCrossOffer.results?.length > 0 ||
    searchByOtherOffer.results?.length > 0 ||
    catalogByGroup.results?.length > 0 ||
    promoProducts.results?.length > 0;

  // Перевіряємо чи всі запити завершені
  const isAllLoaded =
    !catalogByGroup.loading &&
    !searchStatus.loading &&
    !searchByArticleOwn.loading &&
    !searchByCrossOwn.loading &&
    !searchByOtherOwn.loading &&
    !searchByArticleOffer.loading &&
    !searchByCrossOffer.loading &&
    !searchByOtherOffer.loading &&
    !promoProducts.loading;

  const hasData =
    catalogByGroup.data?.results?.length > 0 ||
    searchByArticleOwn.data?.results?.length > 0 ||
    searchByArticleOffer.data?.results?.length > 0 ||
    searchByCrossOwn.data?.results?.length > 0 ||
    searchByCrossOffer.data?.results?.length > 0 ||
    searchByOtherOwn.data?.results?.length > 0 ||
    searchByOtherOffer.data?.results?.length > 0 ||
    promoProducts.data?.results?.length > 0;

  if (isLoading && !hasData) return <ProductListSkeleton />;

  const handleCloseFilterSideBar = () => {
    setShowFilterSideBar(false);
  };
  const handleCloseSortSideBar = () => {
    setShowSortSideBar(false);
  };
  const handleClosePerViewSideBar = () => {
    setShowPerViewSideBar(false);
  };

  const renderPtoductsNewTable = (type, title, data) => {
    if (data.results && data.results?.length > 0) {
      return (
        <Grid container item xs={12} spacing={0} style={{display: 'block'}}>
          <React.Fragment>
            {true && (
              <div className="listing-info" style={{gap: '30px'}}>
                <div className="listing-info__text d-flex items-center gap-10">
                  {!isDesktop && (
                    <button
                      onClick={() => setShowFilterSideBar(true)}
                      className="btn icon-btn p-2">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M16.5 2.25H1.5L7.5 9.345V14.25L10.5 15.75V9.345L16.5 2.25Z"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  )}
                  <MenuDrawer
                    onClose={handleCloseFilterSideBar}
                    side="left"
                    isOpen={showFilterSideBar}>
                    <div className="filter mt-4 p-4">
                      <Filters
                        showedCount={countAll}
                        currencyMainContr={currencyMainContr}
                        searchRealAvailability={searchRealAvailability}
                        searchByArticle={searchByArticle}
                        catalogTree={catalog}
                      />
                      {brandsLayout && renderBrandsFilter()}
                    </div>
                  </MenuDrawer>
                  {!isDesktop && (
                    <button
                      onClick={() => setShowSortSideBar(true)}
                      className="btn icon-btn p-2">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M4.71764 10.7175L4.50014 10.9425V5.25C4.50014 5.05109 4.42112 4.86032 4.28047 4.71967C4.13982 4.57902 3.94905 4.5 3.75014 4.5C3.55123 4.5 3.36046 4.57902 3.21981 4.71967C3.07916 4.86032 3.00014 5.05109 3.00014 5.25V10.9425L2.78264 10.7175C2.64141 10.5763 2.44987 10.4969 2.25014 10.4969C2.05041 10.4969 1.85887 10.5763 1.71764 10.7175C1.57641 10.8587 1.49707 11.0503 1.49707 11.25C1.49707 11.4497 1.57641 11.6413 1.71764 11.7825L3.21764 13.2825C3.28897 13.3508 3.37308 13.4043 3.46514 13.44C3.55491 13.4797 3.65199 13.5002 3.75014 13.5002C3.84829 13.5002 3.94536 13.4797 4.03514 13.44C4.1272 13.4043 4.21131 13.3508 4.28264 13.2825L5.78264 11.7825C5.85257 11.7126 5.90804 11.6296 5.94588 11.5382C5.98373 11.4468 6.00321 11.3489 6.00321 11.25C6.00321 11.1511 5.98373 11.0532 5.94588 10.9618C5.90804 10.8704 5.85257 10.7874 5.78264 10.7175C5.71271 10.6476 5.62969 10.5921 5.53833 10.5543C5.44696 10.5164 5.34903 10.4969 5.25014 10.4969C5.15124 10.4969 5.05332 10.5164 4.96195 10.5543C4.87059 10.5921 4.78757 10.6476 4.71764 10.7175V10.7175ZM8.25014 6H15.7501C15.9491 6 16.1398 5.92098 16.2805 5.78033C16.4211 5.63968 16.5001 5.44891 16.5001 5.25C16.5001 5.05109 16.4211 4.86032 16.2805 4.71967C16.1398 4.57902 15.9491 4.5 15.7501 4.5H8.25014C8.05123 4.5 7.86046 4.57902 7.71981 4.71967C7.57916 4.86032 7.50014 5.05109 7.50014 5.25C7.50014 5.44891 7.57916 5.63968 7.71981 5.78033C7.86046 5.92098 8.05123 6 8.25014 6V6ZM15.7501 8.25H8.25014C8.05123 8.25 7.86046 8.32902 7.71981 8.46967C7.57916 8.61032 7.50014 8.80109 7.50014 9C7.50014 9.19891 7.57916 9.38968 7.71981 9.53033C7.86046 9.67098 8.05123 9.75 8.25014 9.75H15.7501C15.9491 9.75 16.1398 9.67098 16.2805 9.53033C16.4211 9.38968 16.5001 9.19891 16.5001 9C16.5001 8.80109 16.4211 8.61032 16.2805 8.46967C16.1398 8.32902 15.9491 8.25 15.7501 8.25ZM15.7501 12H8.25014C8.05123 12 7.86046 12.079 7.71981 12.2197C7.57916 12.3603 7.50014 12.5511 7.50014 12.75C7.50014 12.9489 7.57916 13.1397 7.71981 13.2803C7.86046 13.421 8.05123 13.5 8.25014 13.5H15.7501C15.9491 13.5 16.1398 13.421 16.2805 13.2803C16.4211 13.1397 16.5001 12.9489 16.5001 12.75C16.5001 12.5511 16.4211 12.3603 16.2805 12.2197C16.1398 12.079 15.9491 12 15.7501 12Z"
                          fill="black"
                        />
                      </svg>
                    </button>
                  )}
                  <MenuDrawer
                    side="right"
                    isOpen={showSortSideBar}
                    onClose={handleCloseSortSideBar}>
                    <SortForm
                      onClose={handleCloseSortSideBar}
                      onSideBar={true}
                      currentSortItem={sorting}
                      setSorting={setSorting}
                    />
                    <PerView
                      onChange={onPerViewChange}
                      type={type}
                      onSideBar={true}
                    />
                  </MenuDrawer>
                  {/*<MenuDrawer*/}
                  {/*  side="right"*/}
                  {/*  isOpen={showPerViewSideBar}*/}
                  {/*  onClose={handleClosePerViewSideBar}>*/}
                  {/*  <PerView*/}
                  {/*    onChange={onPerViewChange}*/}
                  {/*    onSideBar={true}*/}
                  {/*    type={type}*/}
                  {/*  />*/}
                  {/*</MenuDrawer>*/}
                  {type === 'catalogByGroup' ? (
                    <p className={classes.searchedAtCatalogs}>{title}: </p>
                  ) : (
                    <>{title}: </>
                  )}
                  <b>
                    {/*{type !== 'catalogByGroup' && type !== 'searchByOtherOwn' ? (
                      <>
                        {false
                          ? ' ' +
                          searchStatus.searchString +
                          ' (' +
                          (data.results?.length + ' ' + t('common:pieces')) +
                          ')'
                          : ' (' +
                          data.results?.length +
                          ' ' +
                          t('common:pieces') +
                          ')'}{' '}
                      </>
                    ) : (*/}
                    <>{data?.num_of_products}</>
                    {/*)}*/}
                  </b>
                </div>
                <div style={{display: 'flex', gap: 30}}>
                  {isDesktop && (
                    <PerView onChange={onPerViewChange} type={type} />
                  )}
                  {isDesktop && (
                    <SortForm
                      onClose={handleCloseSortSideBar}
                      setSorting={setSorting}
                    />
                  )}
                  {isDesktop && (
                    <div className="display-btns">
                      <BlockTypeToggleButton
                        showPage={showPage}
                        typePage={typePage}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
            {typePage === 'cardVr' || typePage === 'cardHr' ? (
              <PtoductsNewTableColumns
                searchAvailability={searchAvailability}
                sorting={sorting}
                cartAll={cartAll}
                currencyMainContr={currencyMainContr}
                //currencyMainSite={currencyMainSite}
                currencyMain={currencyMain}
                typePage={typePage}
                type={type}
                data={data}
                addToCart={addToCart}
                setDialogData={setDialogData}
                setPhotosGallery={setPhotosGallery}
                handleUuidInfo={handleUuidInfo}
                //showProductCart={showProductCart}
                dialogData={dialogData}
                photosGallery={photosGallery}
                anchorElInfo={anchorElInfo}
                searchStatus={searchStatus}
                {...(type === 'catalogByGroup'
                  ? {requestForCatalogByGroup}
                  : {})}
              />
            ) : (
              <PtoductsNewTable
                searchAvailability={searchAvailability}
                sorting={sorting}
                cartAll={cartAll}
                currencyMainContr={currencyMainContr}
                //currencyMainSite={currencyMainSite}
                currencyMain={currencyMain}
                typePage={typePage}
                type={type}
                data={data}
                addToCart={addToCart}
                setDialogData={setDialogData}
                setPhotosGallery={setPhotosGallery}
                handleUuidInfo={handleUuidInfo}
                //showProductCart={showProductCart}
                //Передаем в props поля, при изменении которых не перерисовывать окно поиска
                dialogData={dialogData}
                photosGallery={photosGallery}
                anchorElInfo={anchorElInfo}
                {...(type === 'catalogByGroup'
                  ? {requestForCatalogByGroup}
                  : {})}
              />
            )}
          </React.Fragment>
        </Grid>
      );
    } else {
      return <ProductListSkeleton />;
    }
  };

  const showPage = type => event => {
    setTypePage(type);
    localStorage.setItem('TypePage', type);
  };

  const searchByArticle =
    (searchByArticleOwn.results && searchByArticleOwn.results?.length > 0) ||
    (searchByArticleOffer.results && searchByArticleOffer.results?.length > 0)
      ? true
      : false;

  const renderNoProductsLayout = () => {
    if (
      search.search.includes('?q=') &&
      searchByArticleOwn?.results?.length === 0 &&
      searchByCrossOwn?.results?.length === 0 &&
      searchByOtherOwn?.results?.length === 0 &&
      searchByArticleOffer?.results?.length === 0 &&
      searchByCrossOffer?.results?.length === 0 &&
      searchByOtherOffer?.results?.length === 0
    ) {
      return (
        <NoProducts
          variant="catalogProducts"
          title={search.search.split('=')[1].replace(/&.*/, '')}
        />
      );
    }
    if (
      search.search.includes('?article=') &&
      searchByArticleOwn?.results?.length === 0
    ) {
      return (
        <NoProducts
          variant="catalogProducts"
          title={search.search.split('=')[1].split('&')[0]}
        />
      );
    }
    if (
      search.pathname.includes('/product-groups/') &&
      catalogByGroup?.results?.length === 0
    ) {
      return (
        <NoProducts
          variant="catalogProducts"
          title={
            search.pathname.split('/')[search.pathname.split('/')?.length - 1]
          }
        />
      );
    }
    if (
      search.pathname.includes('/brand_list/') &&
      catalogByGroup?.results?.length === 0
    ) {
      return <NoProducts variant="catalogProducts" />;
    }
    if (
      search.pathname.includes('/promotion/') &&
      promoProducts.results?.length === 0
    ) {
      return <NoProducts variant="catalogProducts" />;
    }
  };

  const groupUrl = search.pathname.split('/')[2];
  const subGroupUrl = search.pathname.split('/')[3];
  const pageData = catalogTree?.data?.result
    ?.find(item => item?.url_repr === groupUrl)
    ?.sub_items?.find(item => item.url_repr === subGroupUrl);

  if (
    search.pathname.includes('brand_list') &&
    !searchStatus.loading === false
  ) {
    return (
      <>
        <ProductListSkeleton />
      </>
    );
  }
  if (
    search.search.includes('?q=') &&
    catalog?.data?.filter_block?.length <= 0
  ) {
    return (
      <>
        <ProductListSkeleton />
      </>
    );
  }

  const renderResults = () => {
    // const location = search;
    const results = [];

    const searchParams = new URLSearchParams(window.location);
    const searchStr = searchParams.get('q');

    // хай буде, можливо пригодиться
    // const url = new URL(window.location.href);
    // const articleHref = url.search.includes('article=');
    const productGroupsHref =
      search.pathname.includes('/product-groups/') ||
      search.pathname.includes('/brand_list/');

    const isPromotionPage = search.pathname.includes('/promotion');

    // Каталог
    if (catalogByGroup.results?.length > 0 && searchStr === null) {
      results.push(
        renderPtoductsNewTable(
          'catalogByGroup',
          t('common:found_in_catalogues'),
          brandsLayout ? brandCatalogByGroup : catalogByGroup,
        ),
      );
    }

    // Промо товари
    if (promoProducts.results?.length > 0 && isPromotionPage) {
      results.push(
        renderPtoductsNewTable(
          'promoProducts',
          t('common:found_promo_item'),
          promoProducts,
        ),
      );
    }

    // Точні співпадіння
    if (searchByArticleOwn.results?.length > 0 && !productGroupsHref) {
      results.push(
        renderPtoductsNewTable(
          'searchByArticleOwn',
          t('common:found_by_article'),
          searchByArticleOwn,
        ),
      );
    } else if (searchByArticleOwn.loading) {
      results.push(
        <div key="article-own-loading" className="section-loading">
          <Skeleton height={100} />
        </div>,
      );
    }

    // Аналоги
    if (searchByCrossOwn.results?.length > 0 && !productGroupsHref) {
      results.push(
        renderPtoductsNewTable(
          'searchByCrossOwn',
          t('common:found_analogues'),
          searchByCrossOwn,
        ),
      );
    } else if (searchByCrossOwn.loading) {
      results.push(
        <div key="cross-own-loading" className="section-loading">
          <Skeleton height={100} />
        </div>,
      );
    }

    // Пошук по назві
    if (searchByOtherOwn.results?.length > 0 && !productGroupsHref) {
      results.push(
        renderPtoductsNewTable(
          'searchByOtherOwn',
          t('common:Search_parts'),
          searchByOtherOwn,
        ),
      );
    } else if (searchByOtherOwn.loading) {
      results.push(
        <div key="other-own-loading" className="section-loading">
          <Skeleton height={100} />
        </div>,
      );
    }

    // Точні співпадіння в пропозиціях
    if (searchByArticleOffer.results?.length > 0 && !productGroupsHref) {
      results.push(
        renderPtoductsNewTable(
          'searchByArticleOffer',
          t('common:under_the_order'),
          searchByArticleOffer,
        ),
      );
    } else if (searchByArticleOffer.loading) {
      results.push(
        <div key="article-offer-loading" className="section-loading">
          <Skeleton height={100} />
        </div>,
      );
    }

    // Аналоги в пропозиціях
    if (searchByCrossOffer.results?.length > 0 && !productGroupsHref) {
      results.push(
        renderPtoductsNewTable(
          'searchByCrossOffer',
          t('common:analogs_on_order'),
          searchByCrossOffer,
        ),
      );
    } else if (searchByCrossOffer.loading) {
      results.push(
        <div key="cross-offer-loading" className="section-loading">
          <Skeleton height={100} />
        </div>,
      );
    }

    // Пошук по назві в пропозиціях
    if (searchByOtherOffer.results?.length > 0 && !productGroupsHref) {
      results.push(
        renderPtoductsNewTable(
          'searchByOtherOffer',
          t('common:the_rest_is_on_order'),
          searchByOtherOffer,
        ),
      );
    } else if (searchByOtherOffer.loading) {
      results.push(
        <div key="other-offer-loading" className="section-loading">
          <Skeleton height={100} />
        </div>,
      );
    }
    return results;
  };

  // Показуємо "Нічого не знайдено" тільки коли всі запити завершені і немає результатів
  const showNoResults = isAllLoaded && !hasAnyResults;

  return (
    <>
      <Helmet>
        <meta name="description" content={pageData?.meta_desc ?? ''} />
        <meta name="keywords" content={pageData?.meta_keywords ?? ''} />
        <title>{pageData?.meta_title ?? 'DaniParts'}</title>
      </Helmet>
      <main>
        <div className="wrapper-inner">
          {/* <BreadCrumbs items={breadcrumbItems} /> */}
          {brandsLayout ||
            promotionLayout ||
            (searchStatus.loading === false && (
              <div style={{margin: '15px 0'}} className="breadcrumbs_container">
                <BreadcrumbsForSearch />
              </div>
            ))
          //   : (
          //   <div>
          //     <div className="my-3" style={{maxWidth: '600px'}}>
          //       <Skeleton className="bread" variant="rect" height={20} />
          //     </div>
          //   </div>
          // )
          }
        </div>
        <div className={clsx('wrapper-inner mb-5')}>
          <div className="row">
            <div
              className={clsx(
                'col-xxl-2 col-lg-3 col-12 filter d-lg-block d-none',
                brandsLayout ? 'mt-5' : '',
              )}>
              {isDesktop && (
                <>
                  {!promotionLayout && (
                    <>
                      <Filters
                        showedCount={countAll}
                        currencyMainContr={currencyMainContr}
                        searchRealAvailability={searchRealAvailability}
                        searchByArticle={searchByArticle}
                        brandsLayout={brandsLayout}
                        catalogTree={catalog}
                      />
                      {brandsLayout && renderBrandsFilter()}
                    </>
                  )}
                </>
              )}

              {/* <PromotionsSlider /> */}

              {searchStatus.loading === false && (
                <>
                  {!promotionLayout && (
                    <div className={classes.randomProduct}>
                      <SliderRandomProduct
                        settingsRandomProductSlider={
                          settingsRandomProductSlider
                        }
                        showFilter={showFilter}
                        setPhotosGallery={setPhotosGallery}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
            <div
              className={
                promotionLayout ? 'col-12' : 'col-xxl-10 col-lg-9 col-12'
              }>
              {!brandsLayout && !promotionLayout && (
                <SliderPromo
                  settingsPromotionSlider={settingsPromotionSlider}
                />
              )}

              {isLoading ? (
                <div className={classes.content}>
                  <ProductListSkeleton />
                </div>
              ) : hasAnyResults ? (
                <div className={classes.content}>{renderResults()}</div>
              ) : showNoResults ? (
                <>{renderNoProductsLayout()}</>
              ) : (
                <div className={classes.content}>
                  <ProductListSkeleton />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <div className="products-block about">
        <div className="wrapper-inner">
          <div className="products-block__header">
            <h2 className="title mb-4">SEO текст</h2>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="about-context">
                <div className="about-context__inner">
                  <p>
                    Компанія «ДАНІ-ПАРТС» пропонує широкий асортимент запасних
                    частин до вантажних автомобілів європейських виробників.
                    Розпочавши свою діяльність у 2003 році, ми стали одними із
                    лідерів постачання запчастин до вантажних автомобілів на
                    українському ринку.
                  </p>
                  <p>
                    Наша команда здійснює продаж запчастин до вантажних
                    автомобілів марок DAF, MAN, VOLVO, SCANIA, MERCEDES, RENAULT
                    та IVECO, а саме: деталей кузова та освітлення, водяних
                    насосів, радіаторів, інтеркулерів, насосів та циліндрів
                    підйому кабіни та деталей моторної групи. Усі запчастини
                    виготовляються на заводах Європи та Азії.
                  </p>
                  <p>
                    Ми зібрали команду висококваліфікованих працівників, які
                    прагнуть забезпечити максимально вигідні умови співпраці для
                    Вас. При розширенні асортименту нашої продукції ми завжди
                    враховуємо основні тенденції та попит ринку автозапчастин,
                    щоб запропонувати Вам найактуальніші позиції за доступними
                    цінами. Наші спеціалісти допоможуть підібрати запчастини до
                    Вашого вантажного автомобіля, а також організують своєчасну
                    доставку товару по всій Україні.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
        <AddToCartDialog
          dialogData={dialogData}
          handleClose={handleClose}
          currencyMainContr={currencyMainContr}
          currencyMain={currencyMain}
          customerGroupId={customer_group_id}
          authentication={authentication}
          discountsByProduct={
            dialogData.row && dialogData.row.discounts_by_quantity_sum_of_order
              ? dialogData.row.discounts_by_quantity_sum_of_order
              : dialogData.row && dialogData.row.balance[0] !== undefined
              ? dialogData.row &&
                dialogData.row.balance[0].discounts_by_quantity_sum_of_order
              : ''
          }
          lastItemBreadcrumb={lastItemBreadcrumb}
        />
      </main>
    </>
  );
};

function mapState(state) {
  const {
    catalogByGroup,
    searchByArticleOwn,
    searchByArticleOffer,
    searchByCrossOwn,
    searchByCrossOffer,
    searchByOtherOwn,
    searchByOtherOffer,
    searchStatus,
    // searchParams,
    cart,
    // listMyFavorite,
    searchParams,
    authentication,
    dataPromotionList,
    catalogTree,
    catalogPage,
  } = state;

  const {searchAvailability} = state.searchParams;

  const {brands} = state.panelData;
  const {customer_id, sell_currency_id} = state.userSelectedData;
  const {currencies, main_currency, user_perms} = state.frontendData;
  const {customer_data} = state.contragentData;

  return {
    brands,
    customer_id,
    main_currency,
    user_perms,
    customer_data,
    sell_currency_id,
    currencies,
    catalogTree,

    catalogByGroup,
    searchByArticleOwn,
    searchByArticleOffer,
    searchByCrossOwn,
    searchByCrossOffer,
    searchByOtherOwn,
    searchByOtherOffer,

    // searchParams,
    searchStatus,
    searchAvailability,
    cart,
    // listMyFavorite,
    searchParams,
    authentication,
    dataPromotionList,
  };
}

const actionCreators = {
  setSearchDataAndSearch: searchActions.setSearchDataAndSearch,
  setTypingSearchValue: searchActions.setTypingSearchValue,
  search: searchActions.search,
  addToCart: cartActions.addToCart,
  // getCart: cartActions.getCart,
  historySearch: searchActions.historySearch,
  getMyFavorite: searchActions.getMyFavorite,
  searchPromotions: searchActions.searchPromotions,
  // getContragentData: userActions.getContragentData
  searchPromotionList: searchActions.searchPromotionList,
};

class Wrapper extends React.Component {
  componentDidMount() {
    this.props.getMyFavorite();
    // if (!this.props.cart.list) this.props.getCart();

    const urlParams = new URLSearchParams(this.props.location.search);
    const searchData = {
      q: urlParams.get('q'),
      article: urlParams.get('article'),
      brand: urlParams.get('brand'),
    };

    if (urlParams.has('page')) {
      this.props.setSearchDataAndSearch(searchData);
      this.props.setTypingSearchValue(
        searchData.q ? searchData.q : searchData.article,
      );
    }

    // if (q) {
    //     this.props.resetSearchParams();
    //     this.props.search()
    // }
  }

  componentDidUpdate(prevProps) {
    // Для того чтоб работали стрелки в браузере
    if (this.props.location.search !== prevProps.location.search) {
      const urlParams = new URLSearchParams(this.props.location.search);
      const searchData = {
        q: urlParams.get('q'),
        article: urlParams.get('article'),
        brand: urlParams.get('brand'),
      };

      this.props.setSearchDataAndSearch(searchData);
      this.props.setTypingSearchValue(
        searchData.q ? searchData.q : searchData.article,
      );
    }
    // *******************************************
    // 07,09,21 ТЕСТ СМЕНЫ КОНТРАГЕНТА

    // if (
    //     this.props.customer_id !== prevProps.customer_id && this.props.customer_data.credit_limit_currency_id
    // //|| this.props.sell_currency_id !== prevProps.sell_currency_id
    // ) {
    //     // this.props.resetSearchParams();
    //     // Это нужно на случай когда сначала стартует поиск а кпотом приходит инфо о customer_id
    //     // в этом случае переискиваем, поис по setSearchStrAndSearch не отработает
    //     this.props.search();
    //     if (this.props.catalogPage) {
    //         const {page_par: page} = this.props.catalogPage;
    //         page &&
    //         this.props.getCatalogByGroup('setData', page.id, this.props.location.pathname);
    //     }
    // }
    // *******************************************
  }

  render() {
    return <ProductList {...this.props} />;
  }
}

Wrapper.propTypes = {
  history: PropTypes.object,
};

export default connect(mapState, actionCreators)(withRouter(Wrapper));
//export default withRouter(connect( mapState, actionCreators)(Wrapper));
